import { cn } from '../lib/utils.js';

export default function EmptyState({ title, description, action, icon: Icon, className }) {
  return (
    <div className={cn('card flex flex-col items-center gap-3 py-10 text-center', className)}>
      {Icon && <Icon className="text-accent" size={32} />}
      <div>
        <div className="text-lg font-medium">{title}</div>
        {description && <div className="mt-1 text-sm text-zinc-400">{description}</div>}
      </div>
      {action}
    </div>
  );
}
